import { ROLE } from '@/data/default'
import generateUUID from '@/utils/generateUUID'

const USER = [
  {
    id: `ginni_${generateUUID()}`,
    userName: 'Ginni',
    role: ROLE.Business,
    email: 'ginny.lee@gmail.com',
    password: '123456',
  },
  {
    id: `sharon_${generateUUID()}`,
    userName: 'Sharon',
    role: ROLE.Influencer,
    email: 'lin.lin@gmail.com',
    password: '666',
  },
  {
    id: `admin_business_${generateUUID()}`,
    userName: 'AdminBusiness',
    role: ROLE.Business,
    email: 'influme_b@gmail.com',
    password: '66666',
  },
  {
    id: `admin_influencer_${generateUUID()}`,
    userName: 'AdminInfluencer',
    role: ROLE.Influencer,
    email: 'influme_i@gmail.com',
    password: '66666',
  },
]

export {
  USER,
}